import script from "./DefLabels.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefLabels.vue?vue&type=script&lang=ts&setup=true"

import "./DefLabels.vue?vue&type=style&index=0&id=b15d9ae2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b15d9ae2"]])

export default __exports__